
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5.5A11.51 11.51 0 001.2 9.9a.5.5 0 00.4.58.5.5 0 00.57-.4 10.5 10.5 0 110 3.82.5.5 0 00-.98.18A11.5 11.5 0 1012.5.5z"}}),_c('path',{attrs:{"d":"M11.09 14.87a.5.5 0 10.67.74l3.58-3.25v-.01a.5.5 0 00.1-.13l.02-.03a.5.5 0 000-.4c0-.02-.02-.03-.03-.04a.5.5 0 00-.09-.12v-.01l-3.58-3.25a.5.5 0 10-.67.74l2.62 2.38H.5a.5.5 0 000 1h13.2z"}})])
          )
        }
      }
    